import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import PacotesList from '@/features/pacote/PacotesList/PacotesList';
import { PacotesListProvider } from '@/features/pacote/PacotesList/context';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import { fetchDataHandler, fetchNavigation } from '@/lib/fetcher';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';

export const getServerSideProps: GetServerSideProps = async ({ query, req }) => {
  const { destino, travelType, order } = query || {};
  const queryParams = new URLSearchParams();

  if (typeof travelType === 'string') {
    queryParams.set('travelType', sanitizeQueryParams(travelType));
  }

  if (typeof order === 'string') {
    queryParams.set('order', sanitizeQueryParams(order));
  }

  const qs = queryParams.toString().length ? `?${queryParams.toString()}` : '';
  const path = `/pacotes/${destino}${qs}`;
  const [navigation, pageProps] = await Promise.all([fetchNavigation(), fetchDataHandler(path, 'PACOTE LIST', req)]);

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation } };

  return {
    props: {
      data: null,
    },
  };
};

const Page = ({ data, error, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data;
  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag meta={meta} />
      <PacotesListProvider data={data as unknown as PacoteDataType}>
        <PacotesList />
      </PacotesListProvider>
    </AppProvider>
  );
};

export default Page;
